class ContentSummaryElement {
  constructor(type = null, position = 0, length = 0) {
    this.type = type;
    this.position = position;
    this.length = length;
  }
}

module.exports.ContentSummaryElement = ContentSummaryElement;
